import { createRootRoute, Outlet } from '@tanstack/react-router'
import { Toaster } from 'sonner'

function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster position="top-center" richColors />
    </>
  )
}

function NotFound() {
  return (
    <div className="flex items-center justify-center h-screen bg-background">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
        <p className="text-xl text-muted-foreground">Page Not Found</p>
      </div>
    </div>
  )
}

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
})
